import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import api, { formatApiErrorDetail } from "../../lib/api";

export function ListSettingsDialog({ onClose }) {
  const [data, setData] = useState(null);
  const [map, setMap] = useState({});
  useEffect(() => {
    api.get("/newsletters/lists").then(({ data: d }) => {
      setData(d);
      setMap(Object.fromEntries(d.locations.map((l) => [l, d.mapping[l]?.[0] || d.suggested[l]?.[0] || ""])));
    }).catch((e) => toast.error("Couldn't load HubSpot lists", { description: formatApiErrorDetail(e.response?.data?.detail) }));
  }, []);
  const save = async () => {
    try {
      await Promise.all(Object.entries(map).map(([loc, id]) => api.put(`/newsletters/lists/${encodeURIComponent(loc)}`, { list_ids: id ? [id] : [] })));
      toast.success("Recipient lists saved"); onClose();
    } catch (e) { toast.error("Save failed", { description: formatApiErrorDetail(e.response?.data?.detail) }); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl bg-brand-page" data-testid="nl-lists-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl font-normal">Recipient lists by location</DialogTitle>
          <DialogDescription>Newsletters sent from the hub for a location go only to its list. Suggested matches are pre-filled. Review and save.</DialogDescription>
        </DialogHeader>
        {!data ? <p className="text-sm text-brand-tertiary">Loading HubSpot lists…</p> : (
          <div className="space-y-2.5 max-h-[55vh] overflow-y-auto pr-1">
            {data.locations.map((loc) => (
              <div key={loc} className="grid grid-cols-[140px_1fr] items-center gap-3">
                <span className="text-sm text-brand-ink">{loc}</span>
                <select value={map[loc] || ""} onChange={(e) => setMap({ ...map, [loc]: e.target.value })} data-testid={`nl-list-${loc}`} className="border border-brand-border rounded-md px-2 py-2 text-sm bg-brand-surface min-w-0">
                  <option value="">— None —</option>
                  {data.lists.map((l) => <option key={l.id} value={l.id}>{l.name} ({l.size.toLocaleString()})</option>)}
                </select>
              </div>
            ))}
          </div>
        )}
        <div className="flex justify-end"><button onClick={save} disabled={!data} data-testid="nl-lists-save" className="rounded-md bg-brand-ink text-brand-page px-4 py-2 text-sm hover:bg-brand-primary disabled:opacity-50">Save lists</button></div>
      </DialogContent>
    </Dialog>
  );
}
